import { createLangWrapper } from './localizationWrapper'
import { setLocale, isLocaleLoaded } from './i18n-lazy'
import { SNACKBAR_TIMEOUT_DEFAULT } from '@/utils/constants'

// To use new localization library with old syntax from 'vuejs-localization'
export default {
  install(app, i18n) {
    if (!i18n?.global?.t) {
      throw new Error('i18n instance must be provided to localizationCompatPlugin')
    }

    app.config.globalProperties.$lang = createLangWrapper(i18n.global.t)

    const lang = localStorage.selectedLanguage
      ? localStorage.selectedLanguage
      : 'en'

    app.config.globalProperties.$current_lang = lang

    // Track loading state for UI feedback
    app.config.globalProperties.$langLoading = false

    // Async-aware language setter with timeout support
    // Returns: { success: boolean, timedOut: boolean }
    app.config.globalProperties.$setLang = async (newLang) => {
      if (newLang === app.config.globalProperties.$current_lang && isLocaleLoaded(newLang)) {
        return { success: true, timedOut: false }
      }

      app.config.globalProperties.$langLoading = true

      try {
        const result = await setLocale(newLang)

        if (result.success) {
          localStorage.selectedLanguage = newLang
          app.config.globalProperties.$current_lang = newLang
          i18n.global.locale = newLang

          // Font loading with graceful error handling
          try {
            const { loadLanguageFont } = await import('@/utils/fontLoader')
            const fontLoad = loadLanguageFont?.(newLang)
            if (fontLoad?.started) {
              // Access store through app for snackbar notification
              const store = app.config.globalProperties.$store
              store?.dispatch('app/addSnackbar', {
                message: i18n.global.t('hints.loadingFont'),
                timeout: SNACKBAR_TIMEOUT_DEFAULT,
                color: 'info'
              })
            }
          } catch (e) {
            // Font loading is optional - don't block locale change
            console.warn('Font loading unavailable:', e.message)
          }
        }

        return result
      } finally {
        app.config.globalProperties.$langLoading = false
      }
    }

    // Helper to check if language is loaded
    app.config.globalProperties.$isLangLoaded = isLocaleLoaded
  }
}
